import { render, staticRenderFns } from "./Utm.vue?vue&type=template&id=6a6a6818&scoped=true"
import script from "./Utm.vue?vue&type=script&lang=js"
export * from "./Utm.vue?vue&type=script&lang=js"
import style0 from "./Utm.vue?vue&type=style&index=0&id=6a6a6818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6a6818",
  null
  
)

export default component.exports